export type AnnotationEventNameT = {
  ADD_ANNOTATION: 'add_annotation';
  UPDATE_ANNOTATION: 'update_annotation';
  DELETE_ANNOTATION: 'delete_annotation';
  DELETE_ANNOTATIONS: 'delete_annotations';
  TOOL_SELECTED: 'tool_selected';
  CHANGE_CONTROLS: 'change_controls';
  MERGE_POLYGON: 'merge_polygon';
  SUBTRACT_POLYGON: 'subtract_polygon';
};
export const ANNOTATION_EVENT_NAMES: AnnotationEventNameT = Object.freeze({
  ADD_ANNOTATION: 'add_annotation',
  UPDATE_ANNOTATION: 'update_annotation',
  DELETE_ANNOTATION: 'delete_annotation',
  DELETE_ANNOTATIONS: 'delete_annotations',
  TOOL_SELECTED: 'tool_selected',
  CHANGE_CONTROLS: 'change_controls',
  MERGE_POLYGON: 'merge_polygon',
  SUBTRACT_POLYGON: 'subtract_polygon'
});
type QuestionnaireEventNameT = {
  QUESTIONNAIRE_SKIPPED: 'questionnaire_skipped';
  QUESTIONNAIRE_ANSWERED: 'questionnaire_answered';
  QUESTIONNAIRE_UPDATED: 'questionnaire_updated';
};
export const QUESTIONNAIRE_EVENT_NAMES: QuestionnaireEventNameT = Object.freeze({
  QUESTIONNAIRE_SKIPPED: 'questionnaire_skipped',
  QUESTIONNAIRE_ANSWERED: 'questionnaire_answered',
  QUESTIONNAIRE_UPDATED: 'questionnaire_updated'
});
type SAMActionEventNameT = {
  ACCEPT_SAM_SUGGESTION: 'accept_sam_suggestion';
  REJECT_SAM_SUGGESTION: 'reject_sam_suggestion';
  SAM3_MASK_TO_POLYGON: 'sam3_mask_to_polygon';
  SAM3_AUTO_DETECT_TRIGGERED: 'sam3_auto_detect_triggered';
  SAM3_AUTO_DETECT_RESULT: 'sam3_auto_detect_result';
  SAM3_AUTO_DETECT_SUBMIT_ALL: 'sam3_auto_detect_submit_all';
  SAM3_AUTO_DETECT_CANCEL_ALL: 'sam3_auto_detect_cancel_all';
  SAM3_TIGHTNESS_ADJUSTED: 'sam3_tightness_adjusted';
};
export const SAM_ACTION_EVENT_NAMES: SAMActionEventNameT = Object.freeze({
  ACCEPT_SAM_SUGGESTION: 'accept_sam_suggestion',
  REJECT_SAM_SUGGESTION: 'reject_sam_suggestion',
  SAM3_MASK_TO_POLYGON: 'sam3_mask_to_polygon',
  SAM3_AUTO_DETECT_TRIGGERED: 'sam3_auto_detect_triggered',
  SAM3_AUTO_DETECT_RESULT: 'sam3_auto_detect_result',
  SAM3_AUTO_DETECT_SUBMIT_ALL: 'sam3_auto_detect_submit_all',
  SAM3_AUTO_DETECT_CANCEL_ALL: 'sam3_auto_detect_cancel_all',
  SAM3_TIGHTNESS_ADJUSTED: 'sam3_tightness_adjusted'
});
type YoloAnnotationEventNamesT = {
  YOLO_BOUNDING_BOX_CLICK: 'yolo-bounding-box-click';
};
export const YOLO_ANNOTATION_EVENT_NAMES: YoloAnnotationEventNamesT = Object.freeze({
  YOLO_BOUNDING_BOX_CLICK: 'yolo-bounding-box-click'
});
type RelationshipEventNamesT = {
  ADD_RELATIONSHIP: 'add_relationship';
  UPDATE_RELATIONSHIP: 'update_relationship';
  DELETE_RELATIONSHIP: 'delete_relationship';
};
export const RELATIONSHIPS_EVENT_NAMES: RelationshipEventNamesT = Object.freeze({
  ADD_RELATIONSHIP: 'add_relationship',
  UPDATE_RELATIONSHIP: 'update_relationship',
  DELETE_RELATIONSHIP: 'delete_relationship'
});
type ObjectTrackingEventNamesT = {
  OBJECT_TRACKING_RESULT: 'object_tracking_result';
};
export const OBJECT_TRACKING_EVENT_NAMES: ObjectTrackingEventNamesT = Object.freeze({
  OBJECT_TRACKING_RESULT: 'object_tracking_result'
});